import React from "react";
import { Card, Accordion } from "react-bootstrap";
import TutorialPopup from "../../../help/TutorialPopup";
import * as HelpContent from "../../../../utils/HelpContent";
import { DcaType, DcaTypeName } from "../../../../Const";
import DcaTimeEntry from "../dca-bot/DcaTimeEntry";
import DcaIndicatorEntry from "../dca-bot/DcaIndicatorEntry";
import DcaPercentEntry from "../dca-bot/DcaPercentEntry";
import { useDispatch } from "react-redux";
import { CHANGE_DCA_TYPE, CHANGE_FREQUENCY } from "../../../../actions/create-bot-type";
import "./DcaEntryView.scss";

const DcaEntryView = (props) => {
  const { newBot ,t} = props;

  const dispatch = useDispatch();
  const changeDcaType = (type) =>{
    dispatch({
      type: CHANGE_DCA_TYPE,
      payload: type,
    });
    if(type=="buy_down" || type=="sell_up"){
      dispatch({
        type: CHANGE_FREQUENCY,
        payload: 5,
      });
    }
    
  }
   

  const options = Object.keys(DcaType).map((el, id) => (
    <option key={id} value={DcaType[el]}>
      {DcaTypeName[el]}
    </option>
  ));

  let entryComp;
  switch (newBot.dcaType) {
    case DcaType.time:
      entryComp = <DcaTimeEntry newBot={newBot} />;
      break;
    case DcaType.indicator:
      entryComp = <DcaIndicatorEntry newBot={newBot} isEntry={true} t={t}/>;
      break;
    case DcaType.buyDown:
      entryComp = <DcaPercentEntry newBot={newBot} isBuy={true} t={t}/>;
      break;
    case DcaType.sellUp:
      entryComp = <DcaPercentEntry newBot={newBot} isBuy={false} t={t}/>;
      break;
    default:
      break;
  }
  return (
    <>
      <Card>
        <Accordion.Toggle as={Card.Header} eventKey="2">
          3. {t("entry-cond")} {<TutorialPopup content={t("dcaEntry")} />}
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="2">
          <Card.Body className="dca-entry-view">
            <div>
              {t("sel-entry-type")}:
              <select
                value={newBot.dcaType}
                onChange={(e) => changeDcaType(e.target.value)}
                style={{ marginLeft: 15, marginBottom: 20 }}
              >
                {options}
              </select>
            </div>
            {entryComp}
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </>
  );
};

export default DcaEntryView;
